<template>
  <div class="d-flex">
    <qtm-select v-bind="$attrs" :items="vendor.contacts">
      <template v-slot:selection="{ item }">
        {{ contactName(item.raw) }}
        <out-of-office-status v-if="item.raw?.ooo_date_started" class="ml-2" />
      </template>
      <template v-slot:item="{ item, props: itemProps }">
        <v-list-item v-bind="itemProps" title="">
          <v-list-item-title>
            {{ contactName(item.raw) }}
            <out-of-office-status v-if="item.raw?.ooo_date_started" class="ml-2" />
          </v-list-item-title>
        </v-list-item>
      </template>
    </qtm-select>
    <qtm-btn class="ml-2" size="x-large" @click="showCreateContactDialog = true">
      <v-icon>mdi-plus</v-icon>
      <span v-if="!vendor.contacts.length">Add Contact</span>
    </qtm-btn>
    <create-contact-dialog
      v-model="showCreateContactDialog"
      :email-required="emailRequired"
      :vendor="vendor"
      @new-contact="$emit('new-contact', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import type { Contact, Vendor } from '@quotetome/materials-api'
import CreateContactDialog from '@/components/vendors/create-contact-dialog.vue'
import OutOfOfficeStatus from '@/components/vendors/out-of-office-status.vue'

export interface Props {
  emailRequired?: boolean
  vendor: Vendor
}

const props = defineProps<Props>()
defineEmits(['new-contact'])

const showCreateContactDialog = ref(false)

const contactName = (item?: Contact | number) => {
  let contact = item

  if (typeof contact === 'number') {
    contact = props.vendor.contacts.find(c => c.id === item)
  }

  if (contact?.first_name) {
    return `${contact.first_name} ${contact.last_name}`
  }

  return ''
}
</script>
